import React from 'react';

function ErrorState({ message, onRetry }) {
  return (
    <div className="empty-state">
      <div style={{ fontSize: 32, color: 'var(--danger)' }}>⚠</div>
      <div className="empty-state__title" style={{ color: 'var(--danger)' }}>Error</div>
      <div className="empty-state__desc">{message || 'No se pudieron cargar los datos'}</div>
      {onRetry && (
        <button className="btn-primary" onClick={onRetry} style={{ marginTop: 8 }}>
          Reintentar
        </button>
      )}
    </div>
  );
}

export default ErrorState;
